module.exports = __webpack_public_path__ + "common/icon-app-dm-b381a52ee65beca4bc241e5b59e68e77.svg";